import React, { useEffect, useState } from "react";
import i18next from "i18next";
import { DeleteIcon, EditIcon, EyeIcon } from "../../components/Shared/TableActionIcons";

import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import SharedButton from "../../components/Shared/SharedButton";
import { formatDate } from "../Transactions/TransactionsTable";
import { deletePaymentVoucher } from "../../store/slices/VoucherSlice";
import { getCostCenter } from "../../store/slices/CostCenterSlice";
import { FiTrash2 } from 'react-icons/fi';
import ConfirmationModal from "../../components/Shared/ConfirmationModal";
import CustomPagination from "../../components/Shared/CustomPagination";
import TableLoading from "../../components/Shared/TableLoading";
import CustomTable from "../../components/Shared/CustomTable";
import useFetchData from "../../hooks/useFetchData";

function PaymentVoucher() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: voucherData, loading, executeFetch } = useFetchData();
  const [deleteVoucher, setDeleteVoucher] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const { costCenters } = useSelector((state) => state?.costCenter);
  const lang = i18next.language;

  useEffect(() => {
    dispatch(getCostCenter());
    executeFetch("POST", "paymentVouchers", { page: 1, per_page: 10 });
  }, [dispatch, executeFetch]);

  const onPageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "paymentVouchers", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "paymentVouchers", {
      page: voucherData?.page || 1,
      per_page: voucherData?.per_page || 10
    });
  };

  const sequenceBodyTemplate = (rowData, options) => {
    return Number(
      options.rowIndex +
      1 +
      (voucherData?.page - 1) * voucherData?.per_page,
    );
  };
  const costCenterTempelate = (rowData) => {
    const center = costCenters?.data?.find(
      (center) => center?.id === rowData?.cost_center_id,
    );
    return lang === "ar" ? center?.name_ar : center?.name_en;
  };
  const templateBody = (rowData) => {
    return (
      <div className="flex  gap-1">

        <EyeIcon
          onClick={() =>
            navigate("/manager/payment/voucher/view", {
              state: { voucher: rowData },
            })
          }
          title={t("view")}
        />
        <EditIcon
          onClick={() => {
            navigate("/manager/create/payment/voucher", {
              state: { data: rowData },
            });
          }}
          title={t("edit")}
        />
        <DeleteIcon
          onClick={() => {
            setDeleteVoucher(true);
            setSelectedVoucher(rowData);
          }}
          title={t("delete")}
        />
      </div>
    );
  };

  const columnsData = [
    {
      body: templateBody,
      header: t("actions"),
    },
    {
      body: sequenceBodyTemplate,
      header: t("no"),
      style: { width: "3rem" },
    },
    {
      field: "date",
      header: t("date"),
      body: (rowData) => formatDate(rowData?.date),
    },
    {
      body: costCenterTempelate,
      header: t("costCenter"),
    },
    {
      field: "total_amount",
      header: t("total_amount"),
    },
  ];

  return (
    <div>
      <div className="flex justify-end mb-2">
        <div className="flex items-center gap-2">
          <SharedButton
            label={t("create_payment_voucher")}
            icon="pi pi-plus"
            onClick={() => navigate("/manager/create/payment/voucher")}
            className="bg-primary primary-btn"
          />
        </div>
      </div>
      <div>
        <CustomTable
          data={voucherData?.data}
          isLoading={loading}
          loadingIcon={<TableLoading />}
          columns={columnsData}
          rows={voucherData?.per_page}
        />
        {voucherData?.data?.length > 0 && (
          <CustomPagination
            currentPage={voucherData?.page}
            rowsPerPage={voucherData?.per_page}
            totalRecords={voucherData?.total_pages}
            totalRecord={voucherData?.total_record}
            onPageChange={onPageChange}
          />
        )}
      </div>
      <ConfirmationModal
        visible={deleteVoucher}
        setVisible={setDeleteVoucher}
        header={t("delete_confirmation")}
        message={t("do_you_really_want_to_delete_this_item")}
        Icon={FiTrash2}
        acceptLabel={t("delete")}
        rejectLabel={t("cancel")}
        isLoading={dispatch.isLoading} // Note: This might need closer look if we use useFetchData for delete too, but for now keeping it as is or using locally
        onAccept={() => {
          dispatch(deletePaymentVoucher(selectedVoucher?.id))?.then((res) => {
            if (res.payload) {
              setDeleteVoucher(false);
              handleRefresh();
            }
          });
        }}
      />
    </div>
  );
}

export default PaymentVoucher;
